import { Card, CardContent } from "@altimateai/lego";
import { Button } from "@altimateai/lego";
import styles from "./styles.module.scss";
import classnames from "classnames";
import no_resource from "../../assets/images/no_resource.svg";
import { Link } from "react-router-dom";

const NoDatasets = () => {
  return (
    <div className={styles.no_datasets}>
      <Card className={styles.card}>
        <CardContent className="al-flex al-justify-center al-pt-4">
          <div className={classnames("al-flex al-flex-col al-items-center p-4", styles.container)}>
            <img src={no_resource} alt="No Datasets" className={styles.img} />
            <h2 className="mt-4 mb-4 text-black">No Datasets Found</h2>
            <p className="text-muted text-center">
              This means your onboarding setup is not completed.
            </p>
            <Link to="/quickstart">
              <Button>Go to Quickstart</Button>
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export { NoDatasets };
